<div>
  <h3 class="title">{{title}}</h3>
  <div class="usage-info">
    <div>
      <div class="chart-bar-wrapper">
        <div class="chart-bar-inactive" [ngStyle]="{'width': 105 - chartValue + '%'}"></div>

        <div class="chart-bar-active" [ngStyle]="{'width': chartValue + '%'}">
          <div class="chart-bar-active-inner" [ngStyle]="{'width': (100 * 100 / chartValue) + '%'}"></div>
        </div>
      </div>
      <span class="total-used">{{formattedTotalUsed}}</span> / <span class="total">{{formattedTotal}} ({{formattedPercentageUsed}})</span>
    </div>
    <div>
      <button class="button-toggle" [class.button-toggle--open]="open" (click)="toggleOpen()">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
    </div>
  </div>
  @if (open) {
    <div class="media">
      <div class="item">
        <div class="icon"><i class="far fa-image-polaroid"></i></div>
        <div class="info">
          <span class="count">{{ images | shortNumber }}</span>
          <span class="description" i18n [class.nl]="locale === 'nl'">Image (1 credit)</span>
        </div>
      </div>
      <div class="item">
        <div class="icon"><i class="fas fa-play-circle"></i></div>
        <div class="info">
          <span class="count">{{ videos | shortNumber }}</span>
          <span class="description" i18n [class.nl]="locale === 'nl'">Video (12 credits)</span>
        </div>
      </div>
      <div class="item">
        <div class="icon">
          <img src="assets/icons/gif.svg" class="consumption-icon" />
        </div>
        <div class="info">
          <span class="count">{{ gifs | shortNumber }}</span>
          <span class="description" i18n [class.nl]="locale === 'nl'">GIF (12 credits)</span>
        </div>
      </div>
    </div>
  }
</div>
